export default __webpack_public_path__ + "static/media/siemens.a291589d.png";